export default __webpack_public_path__ + "static/media/red.942bbbf2.svg";